import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  accordion: {
    backgroundColor: "transparent",
    boxShadow: "none",
    "& &__summary": {
      border: "none"
    },
    "& &__summary-count": {
      fontSize: 12,
      borderRadius: "50%",
      minHeight: 18,
      height: 18,
      width: 18,
      minWidth: 18,
      lineHeight: "normal",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    "& .MuiCollapse-container": {
      padding: 8,
      margin: -8
    }
  }
}));
